<script setup lang="ts">
import { ref } from "vue"

withDefaults(
    defineProps<{
        type?: "danger" | "success" | "warning" | "info" | "primary" | "secondary"
        dismissible?: boolean
    }>(),
    {
        type: "info",
        dismissible: false,
    },
)

const emit = defineEmits<{ close: [] }>()

const visible = ref(true)

function close() {
    visible.value = false
    emit("close")
}
</script>

<template>
    <div v-if="visible" :class="`alert alert-${type} d-flex align-items-start`" role="alert">
        <div class="flex-grow-1">
            <slot></slot>
        </div>
        <button v-if="dismissible" type="button" class="close ml-3" @click="close">
            <i class="fa fa-fw fa-times mr-0"></i>
        </button>
    </div>
</template>
